














import { Component, Vue } from 'vue-property-decorator';

import pageHeader from '@/components/atomic/organisms/Header.vue';
import pageFooter from '@/components/atomic/organisms/Footer.vue';

@Component({
  name: 'NormalView',
  components: { 
    pageHeader,
    pageFooter,
  },
})
/**
 * @vuese
 * @group Layout
 * Use for normal view
 */
export default class NormalView extends Vue {
}
